import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserProfile } from '@app/admin/user/model/user-history.model';
import { HistoryModalData, HistoryTableConfig } from '@app/shared/models/history.model';

@Component({
  selector: 'flow-history-modal',
  templateUrl: './history-modal.component.html',
  styleUrls: ['./history-modal.component.scss']
})
export class HistoryModalComponent {
  tables: HistoryTableConfig[] = [];
  userProfiles: UserProfile[] = [];

  constructor(
    public dialogRef: MatDialogRef<HistoryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HistoryModalData
  ) {
    this.tables = this.data.tables.filter(table => table.data && table.data.length > 0);
    this.userProfiles = this.data.userProfiles || [];
  }

  close(): void {
    this.dialogRef.close();
  }
}
